export const routes = {
  events: "/events",
  eventsNew: "/org/events/new",
  eventsTrending: "/events/trending",
  home: "/",
  about: "/about",
  profile: "/profile",
  myLocal: "/my-local",
  settings: "/settings",
  support: "mailto:hello@localplatform.co",
  switchAccount: "/home?treatment=switch-account",

  admin: {
    root: "/admin",
    events: {
      create: "/admin/events/create",
      edit: (id: string) => `/admin/events/${id}/edit`,
      view: (id: string) => `/admin/events/${id}`,
      attendees: (id: string) => `/admin/events/${id}/attendees`,
    },
  },

  event: {
    edit: (id: string) => `/admin/events/${id}/edit`,
    view: (id: string) => `/events/${id}`,
  },

  org: {
    profile: (slug: string) => `/profile/org/${slug}`,
    profileEdit: (slug: string) => `/profile/org/${slug}/edit`,
    events: (slug: string) => `/profile/org/${slug}/events`,
  },

  user: {
    profile: (username: string) => `/profile/${username}`,
    profileEdit: (username: string) => `/profile/${username}/edit`,
  },

  // Auth routes
  auth: {
    signInWithRedirect: (redirectUrl: string) =>
      `/auth/sign-in?redirect_url=${redirectUrl}`,
    org: { create: "/auth/org/create" },
    organizations: "/auth/organizations",
    resetPassword: "/auth/reset-password",
    signIn: "/auth/sign-in",
    signOut: "/auth/sign-out",
    signUp: "/auth/sign-up",
  },

  search: {
    root: "/search",
    events: "/search?entity=events",
    orgs: "/search?entity=orgs",
  },

  terms: "/terms",
  privacy: "/privacy",
};

export function getHomeRoute(exploreMode?: "local" | "beyond") {
  if (exploreMode) return `${routes.home}?explore_mode=${exploreMode}`;

  return routes.home;
}
